
const en = {
  loginText:"Log in",
  header: {
    back: "BACK",
    menus:  [
      {name:"Home","path":"home"},
      {name:"Lyra","path":"tianqin"},
      {name:"Archer","path":"sheshou"},
      {name:"Borderline","path":"linyuan"},
      {name:"Cassiopeia","path":"xianhou"},
      {name:"Titan","path":"taitan"},
      //{name:"Document","path":"interface"},
      {name:"Contact","path":"contact"}
    ]
  },
  metaInfoData: {
    title:"Star Media +",
    description: "Star plus AD is a one-stop traffic monetization platform under Star Media. For various product types such as PC, H5, APP, applet and also varied monetization scenes, it provides corresponding forms, budgets and interfaces to help developers to make though. The core members of our team are former professionals in the commercial product teams of Baidu and Xiaomi，equipped with rich experience in product development and operation. The Star+ platform has now provided access to nearly 1,000 media, and the daily advertising impressions have exceeded 1 billion.",
    home: {
      title: "Starmedia",
      keywords: "Starmedia,starplus,monetization,borderline,zjy news feed,big data,ai",
      description: "Star plus AD is a one-stop traffic monetization platform under Star Media. For various product types such as PC, H5, APP, applet and also varied monetization scenes, it provides corresponding forms, budgets and interfaces to help developers to make though. The core members of our team are former professionals in the commercial product teams of Baidu and Xiaomi，equipped with rich experience in product development and operation. The Star+ platform has now provided access to nearly 1,000 media, and the daily advertising impressions have exceeded 1 billion."
    },
    taitan: {
      title: "Titan Risk Control System",
      keywords: "Titan,risk control system,ai,blockchain,data analysis",
      description: "Risk Control Engine Based on “AI + Blockchain” Technology"
    },
    linyuan: {
      title: "Borderline",
      keywords: "Borderline,search platform,star plus,monetization,big data,ai",
      description: "AI-based Search Platform"
    },
    xianhou: {
      title: "Cassiopeia Intent Engine",
      keywords: "Cassiopeia,intent engine,ai,machine learning,intent-oriented recommendation model,nlp",
      description: "Deep-learning-based Intent Engine",
    },
    qianfanyun: {
      title: "Qianfan Cloud",
      keywords: "Qianfan cloud,saas,Integrated Service Platform,live,Marketing",
      description: "Integrated Service Platform for Content Ecology in Emerging Market"
    },
    projectList:[
      {
        projectName: "Lyra",
        keywords: "Lyra,pc h5 advertising platform,star plus,monetization,big data,ai",
        description: "PC / H5 Advertising Platform"
      },
      {
        projectName: "Archer",
        keywords: "archer,in app advertising platform,star plus,monetization,big data,ai",
        description: "IN-APP Advertising Platform"
      },
      {
        projectName: "Borderline",
        keywords: "Borderline,search platform,star plus,monetization,big data,ai",
        description: "AI-based Search Platform"
      },
    ],
    tianqin: {
      title: "Starmedia-Lyra",
      keywords: "Lyra,pc h5 advertising platform,star plus,monetization,big data,ai",
      description: "PC / H5 Advertising Platform"
    },
    sheshou: {
      title: "Starmedia-Archer",
      keywords: "archer,in app advertising platform,star plus,monetization,big data,ai",
      description: "IN-APP Advertising Platform"
    },
    baolaidian: {
      title: "Starmedia-Jaguar Call",
      keywords: "Jaguar call,ring,call,customized,mass video",
      description: "Customized Product for phone call"
    },
    qushouru: {
      title: "Starmedia-Funny Keyboard",
      keywords: "Funny keyboard,keyboard,ai,emoji,chatcustomized,outside fast",
      description: "Incentive Input Product"
    },
    zhijuyun: {
      title: "Starmedia-ZJY News Feed",
      keywords: "zjy news feed,content+advertising,monetization",
      description: "Content + Advertising” A one-stop integrated services platform "
    },
    contact: {
      title: "Starmedia-CONTACT",
      keywords: "Starmedia, starmedia contact, starmedia adress",
      description: "网际星辰文化传媒（北京）有限公司是一家专注于移动互联网内容生态的高新技术企业，利用“AI+大数据”驱动智慧融媒体的发展。公司创业十年历程中，始终秉承科技创新的理念，坚持以客户需求为产品研发的原始驱动力和方向，坚定地打造一个有责任、有担当的一站式变现服务平台。"
    },
    news: {
      title: "Starmedia-NEWS",
      keywords: "Starmedia,starmedia news",
      description: "网际星辰文化传媒（北京）有限公司是一家专注于移动互联网内容生态的高新技术企业，利用“AI+大数据”驱动智慧融媒体的发展。公司创业十年历程中，始终秉承科技创新的理念，坚持以客户需求为产品研发的原始驱动力和方向，坚定地打造一个有责任、有担当的一站式变现服务平台。"
    },
    about: {
      title: "Starmedia-ABOUT US",
      keywords: "Starmedia,how about starmedia",
      description: "网际星辰文化传媒（北京）有限公司是一家专注于移动互联网内容生态的高新技术企业，利用“AI+大数据”驱动智慧融媒体的发展。公司创业十年历程中，始终秉承科技创新的理念，坚持以客户需求为产品研发的原始驱动力和方向，坚定地打造一个有责任、有担当的一站式变现服务平台。"
    }
  },
  btn:{
    txt:'MORE'
  },
  footer:{
    title1:"MONETIZE",
    title2:"ADVERTIZE",
    per1:"Contacts：Ms.Cui",
    per2:"Contacts：Ms.Wang",
    qq1:"QQ：331291204",
    qq2:"QQ：719459791",
    projectList:[{name:'LYRA',path:'/tianqin'},{name:'ARCHER',path:"/sheshou"},{name:'BORDERLINE',path:'/linyuan'},{name:'CASSIOPEIA',path:'/xianhou'},{name:'TITAN',path:'/taitan'}],
    projectList1:[{name:'CONTACT',path:"/contact"},{name:'STAR-MEDIA',href:"http://www.star-media.cn/"}],
  },
  taitan: {
    banTitle: "Titan",
    banTips:
    "Risk Control Engine Based on “AI + Blockchain” Technology",
    summary: {
      tit1: "AI Empowerment",
      tips1: [
        "Non-human Traffic Identification: identify non-human traffic based on user behavior data， equipment information combined with AI data analysis",
        "Low-quality Traffic Screening: For traffic that passed non-human traffic screening, the platform can identify and screen out low-quality human traffic via users’ long-term historical behavior data and data generated in users’ interaction with content or advertisements."
      ],
      tit2: "Blockchain Technology",
      tips2: [
        "Taking advantage of the tamper-proof characteristics of blockchain, Titan risk control engine can upload the data of analysis results to the chain via smart contracts, thereby improving the security and credibility of the engine."
      ]
    },
    four:[
      {t:"One-stop access", p:"provide professional consulting service and one-stop access service"},
      {t:"Professional background system", p:"convenient and easy to use"},
      {t:"Top-ranking team", p:"full coverage of products, R&D, operation and after-sales service"},
      {t:"Making profits", p:"efficient monetization, high conversion rate and high returns"},
    ]
  },
  linyuan: {
    banTitle: "Borderline",
    banTips: "AI-based Search Platform",
    summary: {
      tit1: "AI empowerment",
      tips1: [
        "Based on AI technology to capture user’s behavior data, Borderline has established a rich basic and personalized label system, which ensures that it can distribute the hot and interesting content to users. It can not only bring profits but also can improve the retention rate, engagement and time of use of the apps.",
      ],
      tit2: "Intelligent search",
      tips2: [
        "Compared with traditional in-app search, Borderline can provide more stable incremental income for traffic apps since it has strong power in news monitoring, hot word mining and personalized distribution."
      ],
      tit3: "Hotspot tracking",
      tips3: [
        "Borderline has the power of covering all the real-time hotspots on the internet to get minute-level processing. It can further estimate the heat trend of the hotspots, thus distributing the content to users with stronger interests in related topics."
      ],
    },
    p1: "Low-quality Traffic Screening: For traffic that passed non-human traffic screening, the platform can identify and screen out low-quality human traffic via users’ long-term historical behavior data and data generated in users’ interaction with content or advertisements.",

  },
  xianhou: {
    banTitle: "Cassiopeia",
    banTips: "Deep-learning-based Intent Engine",
    summary: {
      tit1: "Figure out users’ intent",
      tips1: [
        "Use NLP to obtain users' browsing content in different periods and extract users’ short-term, medium- and long-term interests to understand their true intents.",
      ],
      tit2: "Intent-oriented recommendation model",
      tips2: [
        "Based on the user's true intent obtained via NLP and referring to candidate content, advertising attributes and media attributes, the model recommends content or advertisements that meet users’ intent."
      ],
    }
  },
  sheshou: {
    banTitle: "Archer",
    banTips: "IN-APP Advertising Platform",
    summary: {
      tit1: "Know your users better",
      tips1:[
        "After years of practice in digital marketing, product matrix and content service, we have accumulated enormous amount of user behavior data, which enables us to know your users better.",
      ],
      tit2: "Cover more than 800 million users",
      tips2:[
        "Aggregating the multi-channel traffic distribution strategies of SDK, we help improve the efficiency of traffic monetization and maximize media’s revenue.",
      ],
      tit3: "Flexible forms and multiple interfaces",
      tips3:[
        {name:"banner",isshow:true},
        {name:"open screen ads",isshow:false},
        {name:"feeds ads",isshow:false},
        {name:"bottom floating",isshow:false},
        {name:"fixed block",isshow:false},
        {name:"pop-up ads",isshow:false},
      ],
    },
  },
  home: {
    banTitle: "professional one-stop<br/>service platform<br/>for traffic monetization",
    banTips: "WEB、APP、H5",
    blink:{
      txt1:"MONETIZE",
      txt2:"ADVERTISE"
    },
    three:{
      num1: "Lyra",
      num2: "Archer",
      num3: "Borderline",
      brief1: "PC / H5 Advertising Platform",
      brief2: "IN-APP Advertising Platform",
      brief3: "AI-based Search Platform",
    },
    yinqin:{
      title1: "Cassiopeia Intent Engine",
      title2: "Titan Risk Control System",
    }
  },
  contact: {
    banTitle: "Contact",
    banTips: "CONTACT US",
    summary: {
      tit1: "Adress",
      tips1: "306, block B, Vanke Jinyu International Center, Longyu Dongyi Road, Huilongguan street, Changping District, Beijing",
      tit2: "Phone",
      tips2: "010-82157368-8001",
      tit3: "Email",
      tips3: "sangxi@star-media.cn"

    }
  },
  openaccount: {
    banTitle: "The process for advertisers to open an account",
    summary: {
      tit1: "<h4 class='oah4'>Advertisers need to apply for account opening via e-mail</h4>",
      tips1: "E-mail subject: Apply to open a Star Media account + the account you plan to use<br/>" +
      "To：renshaowei@star-media.cn<br/>" +
      " E-mail Content:<span class='oared'>(all the following information must be provided)</span><br/>The name of your product or service<br/>" +
      " The full name of your company<br/>" +
      " The URL of your company’s website<br/>" +
      " The e-mail address of your company<br/>" +
      " The phone number of your company<br/>" +
      " The industry to which your company or the product you plan to promote belongs(both the primary and secondary industries should be specified，<span class='oablue'>download</span>）",
      tit2: "<h4 class='oah4'>You should wait for an e-mail from account <span class='oared'>【星辰+广告平台】service@star-media.cn</span> which would tell you that your account has been successfully opened.</h4>",
      tips2: "After receiving the application, the customer service of Star Media will help you to open an account on the advertising platform. After the account has been successfully created, the system will send the specific account information to you by email.",
      tit3: "<h4 class='oah4'>Then you can use the account and password in the e-mail to log in and further complete your information on the platform as an advertiser.</h4>",
      tips3: "The website of the advertiser platform:： <br/><span class='oablue'>http://advertiser.iscrv.com/ </span>"

    }
  },
  tianqin: {
    banTitle: "Lyra",
    banTips: "PC / H5 Advertising Platform",
    summary: {
      tit1: "Thousands of media get accessed to Lyra",
      tips1:[
        "Over 1 billion advertisements are displayed every day. Besides, it offers independently- developed risk control systems for media to filter out low-quality traffic and improve eCPM."
      ],
      tit2: "Professional Team",
      tips2:[
        "The core members of our team are former professionals in the commercial product teams of Baidu and Xiaomi and have rich experience in product development and operation."
      ],
      tit3: ["Flexible forms and","multiple interfaces"],
      tips3:[
        {name:"Fixed blocks",isshow:true},
        {name:"floating ads",isshow:false},
        {name:"Couplet ads",isshow:false},
        {name:"feeds ads",isshow:false},
      ],
    },
    desc:[
    {n:"One-stop access",d:"provide professional consulting service and one-stop access service"},
    {n:"Professional background system",d:"convenient and easy to use"},
    {n:"Top-ranking team",d:"full coverage of products, R&D, operation and after-sales service"},
    {n:"Making profits",d:"efficient monetization, high conversion rate and high returns"}
   ]
  },
  login:{
    exitType:['MONETIZE','ADVERTISE'],
    projectList:[{name:'LYRA',path:'/tianqin'},{name:'ARCHER',path:"/sheshou"},{name:'BORDERLINE',path:'/linyuan'},{name:'CASSIOPEIA',path:'/xianhou'},{name:'TITAN',path:'/taitan'},{name:'CONTACT',path:"/contact"},{name:'STAR-MEDIA',href:"http://www.star-media.cn/"}],
    msg:'© Copyright 2018 星辰+ All Rights Reserved  京ICP备11012669号-37'
  },
};

export default en;
